import { Incidence } from './incidence';
import { Model } from './model';
import { ModelSummaryOee } from './summary/model-summary-oee';
import { ModelSummaryTime } from './summary/model-summary-time';

export class OperationSummary {
  constructor(
    public daily?: ModelSummaryTime,
    public incidence?: Incidence,
    public oee?: ModelSummaryOee,
    public realTimePerPiece?: number,
    public medianTimePerPiece?: number,
    public schedulerTaskHash?: string,
    public schedulerTaskStatus?: number,
    public schedulerTaskStartDate?: number,
    public schedulerTaskEndDate?: number,
    public week?: ModelSummaryTime,
    public schedulerTaskTimes?: ModelSummaryTime,
    public schedulerTaskTimesTrend?: ModelSummaryTime,
    public model?: Model
  ) { }

  clone() {
    return new OperationSummary(
      this.daily,
      this.incidence,
      this.oee,
      this.realTimePerPiece,
      this.medianTimePerPiece,
      this.schedulerTaskHash,
      this.schedulerTaskStatus,
      this.schedulerTaskStartDate,
      this.schedulerTaskEndDate,
      this.week,
      this.schedulerTaskTimes,
      this.schedulerTaskTimesTrend,
      this.model
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operation-summary.ts